import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Toast } from 'bootstrap';
import { fromEvent, take } from 'rxjs';
import { EventTypes } from '.';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
  @Output() disposeEvent = new EventEmitter();

  @ViewChild('toastElement', { static: true })
  toastEl!: ElementRef;

  @Input()
  type!: EventTypes;

  @Input()
  title!: string;

  @Input()
  message!: string;

  @Input()
  delay!: number;

  private readonly defaultDelay = 3000;

  toast!: Toast;

  ngOnInit(): void {
    this.show();
  }

  show(): void {
    this.toast = new Toast(this.toastEl.nativeElement, {
      delay: this.delay !== undefined ? this.delay : this.defaultDelay,
    });

    fromEvent(this.toastEl.nativeElement, 'hidden.bs.toast')
      .pipe(take(1))
      .subscribe(() => this.hide());

    this.toast.show();
  }

  hide(): void {
    this.toast.dispose();
    this.disposeEvent.emit();
  }
}
